import { motion } from 'framer-motion';
import { BarChart3 } from 'lucide-react';

const Analytics = () => {
  const analyticsData = [
    {
      image: '/analytics.jpeg',
      title: 'Real-Time Data Visualization',
      description: 'Interactive dashboards displaying live metrics, user behavior patterns, and conversion funnels with comprehensive data insights for informed decision-making.'
    },
    {
      image: '/analytics2.jpeg',
      title: 'Advanced Performance Metrics',
      description: 'Track key performance indicators, campaign ROI, user engagement rates, and revenue analytics with detailed reporting and trend analysis.'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
          <BarChart3 className="w-16 h-16 mx-auto mb-6 text-neon-purple" />
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-neon-purple to-neon-blue bg-clip-text text-transparent">
            Analytics & Performance Tracking
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            We implement advanced analytics systems to track performance, measure growth, and optimize marketing strategies.
          </p>
        </motion.div>

        <div className="space-y-12">
          {analyticsData.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
              className="glass-morphism rounded-2xl overflow-hidden"
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div className="order-2 md:order-1 p-8 flex flex-col justify-center">
                  <h2 className="text-3xl font-bold mb-4 text-neon-purple">{item.title}</h2>
                  <p className="text-text-secondary text-lg leading-relaxed">{item.description}</p>
                </div>
                <div className="order-1 md:order-2">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Analytics;
